




























import { Component, Vue } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import ECharts from "vue-echarts";
import {
    GetAgeData,
    GetSexData,
    GetCommunityData,
    GetCkdData,
    GetTemData,
    GetFollowUpData
} from "@/api/pdStatistics";
@Component({
    components: { ECharts }
})
export default class PdStatisticsPatient extends AbpBase {
    data = [];
    CommunityName=this.$store.state.session.user?this.$store.state.session.user.communityName:'兴安盟人民医院';
    sexOptions = {
        title: {
            text: "慢病肾脏病性别分布情况",
            subtext: this.CommunityName
        },
        tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        toolbox: {
            show: true,
            orient: "vertical",
            left: "right",
            top: "center",
            feature: {
                mark: { show: false },
                dataView: { show: false, readOnly: false },
                magicType: {
                    show: true,
                    type: ["line", "bar", "stack", "tiled"]
                },
                restore: { show: true },
                saveAsImage: { show: true }
            }
        },
        legend: {
            orient: "vertical",
            left: "left",
            top: "50",
            data: []
        },
        series: [
            {
                name: "患者占比",
                type: "pie",
                radius: "55%",
                center: ["50%", "60%"],
                data: [],
                label: {
                    color: "rgba(0, 0, 0, 1)",
                    fontSize: 25,
                    show:true,
                    formatter:'{b}: {c}'
                },
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: "rgba(0, 0, 0, 0.5)"
                    }
                }
            }
        ]
    };
    ageOptions = {
        title: {
            text: "慢病肾脏病年龄段分布情况",
            subtext: this.CommunityName
        },
        color: ["#4cabce"],
        tooltip: {
            trigger: "axis",
            axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
            }
        },
        toolbox: {
            show: true,
            orient: "vertical",
            left: "right",
            top: "center",
            feature: {
                mark: { show: false },
                dataView: { show: false, readOnly: false },
                magicType: {
                    show: true,
                    type: ["line", "bar", "stack", "tiled"]
                },
                restore: { show: true },
                saveAsImage: { show: true }
            }
        },
        grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
        },
        xAxis: [
            {
                type: "category",
                data: [],
                axisTick: {
                    alignWithLabel: true
                }
            }
        ],
        yAxis: [
            {
                type: "value"
            }
        ],
        series: [
            {
                name: "患者数",
                type: "bar",
                barWidth: "60%",
                data: [],
                label: {
                show: true,
                fontSize: 25,
                align: "center",
                verticalAlign: "top",
                lineHeight: 14,
                position: "outside",
                color: "rgba(0, 0, 0, 1)"
                },
            }
        ]
    };
    ckdOptions = {
        title: {
            text: "慢病肾脏病CKD分期统计",
            subtext: this.CommunityName
        },
        tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        toolbox: {
            show: true,
            orient: "vertical",
            left: "right",
            top: "center",
            feature: {
                mark: { show: false },
                dataView: { show: false, readOnly: false },
                magicType: {
                    show: true,
                    type: ["line", "bar", "stack", "tiled"]
                },
                restore: { show: true },
                saveAsImage: { show: true }
            }
        },
        legend: {
            orient: "vertical",
            top: 50,
            left: 10,
            data: []
        },
        series: [
            {
                name: "患者数",
                type: "pie",
                radius: ["50%", "70%"],
                avoidLabelOverlap: false,
                label: {
                    color: "rgba(0, 0, 0, 1)",
                    fontSize: 25,
                    show:true,
                    formatter:'{b}: {c}'
                },
                emphasis: {
                    label: {
                        show: true,
                        fontSize: "30",
                        fontWeight: "bold"
                    }
                },
                labelLine: {
                    show: false
                },
                data: []
            }
        ]
    };
    communityOptions = {
        title: {
            text: "慢病肾脏病社区分布情况",
            subtext: ""
        },
        color: ["#3398DB"],
        tooltip: {
            trigger: "axis",
            axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
            }
        },
        toolbox: {
            show: true,
            orient: "vertical",
            left: "right",
            top: "center",
            feature: {
                mark: { show: false },
                dataView: { show: false, readOnly: false },
                magicType: {
                    show: true,
                    type: ["line", "bar", "stack", "tiled"]
                },
                restore: { show: true },
                saveAsImage: { show: true }
            }
        },
        grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
        },
        xAxis: [
            {
                type: "value",
                axisTick: {
                    alignWithLabel: true
                }
            }
        ],
        yAxis: [
            {
                type: "category",
                data: []
            }
        ],
        series: [
            {
                name: "患者数",
                type: "bar",
                barWidth: "60%",
                data: [],
                label: {
                show: true,
                fontSize: 25,
                align: "center",
                verticalAlign: "top",
                lineHeight: 14,
                position: "outside",
                color: "rgba(0, 0, 0, 1)"
                },
            }
        ]
    };

    temOptions = {
        title: {
            text: "慢病肾脏病社区团队分布情况",
            subtext:  this.CommunityName
        },
        color: ["#3398DB"],
        tooltip: {
            trigger: "axis",
            axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
            }
        },
        toolbox: {
            show: true,
            orient: "vertical",
            left: "right",
            top: "center",
            feature: {
                mark: { show: false },
                dataView: { show: false, readOnly: false },
                magicType: {
                    show: true,
                    type: ["line", "bar", "stack", "tiled"]
                },
                restore: { show: true },
                saveAsImage: { show: true }
            }
        },
        grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
        },
        xAxis: [
            {
                type: "value",
                axisTick: {
                    alignWithLabel: true
                }
            }
        ],
        yAxis: [
            {
                type: "category",
                data: []
            }
        ],
        series: [
            {
                name: "患者数",
                type: "bar",
                barWidth: "60%",
                data: []
            }
        ]
    };
    followUpOptions = {
        title: {
            text: "慢病肾脏病随访分布情况",
            subtext: this.CommunityName
        },
        color: ["#4cabce"],
        tooltip: {
            trigger: "axis",
            axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
            }
        },
        toolbox: {
            show: true,
            orient: "vertical",
            left: "right",
            top: "center",
            feature: {
                mark: { show: false },
                dataView: { show: false, readOnly: false },
                magicType: {
                    show: true,
                    type: ["line", "bar", "stack", "tiled"]
                },
                restore: { show: true },
                saveAsImage: { show: true }
            }
        },
        grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
        },
        xAxis: [
            {
                type: "category",
                data: [],
                axisTick: {
                    alignWithLabel: true
                }
            }
        ],
        yAxis: [
            {
                type: "value"
            }
        ],
        series: [
            {
                name: "随访数",
                type: "bar",
                barWidth: "60%",
                data: [],
                label: {
                show: true,
                fontSize: 25,
                align: "center",
                verticalAlign: "top",
                lineHeight: 14,
                position: "outside",
                color: "rgba(0, 0, 0, 1)"
                },
            }
        ]
    };
    async created() {
        let res = await GetAgeData();
        if (res && res.data) {
            res.data.forEach(item => {
                this.ageOptions.xAxis[0].data.push(item.name);
            });
            this.ageOptions.series[0].data = res.data;
        }

        res = await GetSexData();
        if (res && res.data) {
            res.data.forEach(item => {
                this.sexOptions.legend.data.push(item.name);
            });
            this.sexOptions.series[0].data = res.data;
        }
        res = await GetCommunityData();

        if (res && res.data) {
            res.data.forEach(item => {
                let comName = item.name.replace("社区卫生服务中心", "");
                this.communityOptions.yAxis[0].data.push(comName);
            });
            this.communityOptions.series[0].data = res.data;
        }

        res = await GetCkdData();
        if (res && res.data) {
            res.data.forEach((item, index) => {
            item.name = item.name + "期";
            this.ckdOptions.legend.data.push(item.name);
            });
            this.ckdOptions.series[0].data = res.data;
        }

        res = await GetTemData();
        if (res && res.data) {
            res.data.forEach(item => {
                let temName = item.name.replace("社区卫生服务中心", "");
                this.temOptions.yAxis[0].data.push(temName);
            });
            this.temOptions.series[0].data = res.data;
        }

        res = await GetFollowUpData();
        if (res && res.data) {
            res.data.forEach(item => {
                this.followUpOptions.xAxis[0].data.push(item.name);
            });
            this.followUpOptions.series[0].data = res.data;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdStatistics/pdStatisticsPatient/index.vue